import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import StorefrontIcon from "@mui/icons-material/Storefront";

const BranchHeader = (headerData: any, hideSale: boolean) => {
  const [isCollapes, setCollapse] = useState(true);
  const [phoneNumbers, setPhoneNumbers] = useState<string>();
  useEffect(() => {
    let phone: string[] = [];
    headerData?.headerData?.phoneNumbers?.map((item: string, index: number) =>
      index !== headerData?.headerData?.phoneNumbers?.length
        ? phone.push(item)
        : phone.push(item + "-")
    );
    setPhoneNumbers(phone.toString());
  }, [headerData.headerData !== undefined]);
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          border: "1px solid #EDEFEF",
          borderRadius: "5px",
          backgroundColor: isCollapes ? "#F6F8F9" : "#fff",
        }}
      >
        <Box sx={{ width: "100%", height: "80%", padding: "20px 20px" }}>
          {isCollapes ? (
            <Collapsed storeInformation={headerData!} />
          ) : (
            <Extended
              storeInformation={headerData!}
              phoneNumbers={phoneNumbers}
            />
          )}
        </Box>
        <Box
          sx={{
            width: "100%",
            height: "20%",
            backgroundColor: "rgba(154,175,196,.1)",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={() => setCollapse((prev) => !prev)}
        >
          {isCollapes ? (
            <ArrowDropDownRoundedIcon
              sx={{ color: "#9AAFC4", fontSize: "2rem" }}
            />
          ) : (
            <ArrowDropUpRoundedIcon
              sx={{ color: "#9AAFC4", fontSize: "2rem" }}
            />
          )}
        </Box>
      </Box>
    </div>
  );
};

const Extended = (storeInformation: any) => {
  return (
    <Grid container textAlign="center">
      {storeInformation?.storeInformation?.headerData?.logoBase64 ===
        undefined ||
      storeInformation?.storeInformation?.headerData?.logoBase64 === "" ? (
        <Grid item xs={12} sm={1} md={1}>
          <StorefrontIcon
            style={{
              width: "6vh",
              height: "6vh",
              borderRadius: "50%",
              backgroundColor: "#fff",
              border: "1px solid #C1C7CB",
              padding: "10px",
            }}
          />
        </Grid>
      ) : (
        <Grid item xs={12} sm={1} md={1}>
          <img
            src={`data:image/png;base64,${storeInformation?.storeInformation?.headerData?.logoBase64}`}
            alt={
              storeInformation?.storeInformation?.headerData?.storeTitle ||
              "Store Icon"
            }
            style={{
              width: "6vh",
              height: "6vh",
              borderRadius: "50%",
              backgroundColor: "#fff",
            }}
          />
        </Grid>
      )}
      <Grid
        xs={12}
        sm={4}
        md={4}
        item
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          // borderLeft: "1px solid #C1C7CB",
          paddingTop: "15px",
          alignItems: { xs: "center", sm: "start" },
        }}
      >
        <Typography
          sx={{ fontWeight: "bold", fontSize: "1.1rem", color: "#1D4A87" }}
        >
          مشخصات فروشگاه:
        </Typography>
        <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
          نام فروشگاه:{" "}
          <span style={{ color: "#34495E" }}>
            {storeInformation?.storeInformation?.headerData?.storeTitle}
          </span>
        </Typography>
        <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
          وضعیت فروشگاه:{" "}
          <span style={{ color: "#34495E" }}>
            {storeInformation?.storeInformation?.headerData?.isActive ===
            true ? (
              <b style={{ color: "#28A745" }}>فعال</b>
            ) : (
              <b style={{ color: "#E6123D" }}>غیرفعال</b>
            )}
          </span>
        </Typography>
        <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
          نوع شعبه:{" "}
          <span
            style={{
              color: "#1D4A87",
              fontSize: "1.1rem",
              backgroundColor: "#EDF1F4",
              padding: "5px 10px",
              borderRadius: "5px",
            }}
          >
            {storeInformation?.storeInformation?.headerData?.type === "Online"
              ? "شعبه آنلاین"
              : "شعبه حضوری"}
          </span>
        </Typography>
      </Grid>
      <Grid
        xs={12}
        sm={4}
        md={4}
        item
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          paddingTop: "15px",
          alignItems: { xs: "center", sm: "start" },
        }}
      >
        <Typography
          sx={{ fontWeight: "bold", fontSize: "1.1rem", color: "#1D4A87" }}
        >
          اطلاعات فروشگاه:
        </Typography>
        <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
          آدرس:{" "}
          <span style={{ color: "#34495E" }}>
            {storeInformation?.storeInformation?.headerData?.address}
          </span>
        </Typography>
        <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
          شماره تماس:{" "}
          <span style={{ color: "#34495E" }}>
            {storeInformation.phoneNumbers}
          </span>
        </Typography>
      </Grid>
    </Grid>
  );
};

const Collapsed = (storeInformation: any) => {
  return (
    <Grid container justifyContent={"space-between"} alignItems={"center"}>
      <Grid
        item
        sx={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        <Typography
          sx={{ fontSize: "1.1rem", color: "#1D4A87", fontWeight: "600" }}
        >
          {storeInformation?.storeInformation?.headerData?.logoBase64 ===
            undefined ||
          storeInformation?.storeInformation?.headerData?.logoBase64 === "" ? (
            <StorefrontIcon
              style={{
                width: "6vh",
                height: "6vh",
                borderRadius: "50%",
                backgroundColor: "#fff",
                border: "1px solid #C1C7CB",
                padding: "10px",
              }}
            />
          ) : (
            <img
              src={`data:image/png;base64,${storeInformation?.storeInformation?.headerData?.logoBase64}`}
              alt={
                storeInformation?.storeInformation?.headerData?.storeTitle ||
                "Store Icon"
              }
              style={{
                width: "6vh",
                height: "6vh",
                borderRadius: "50%",
                backgroundColor: "#fff",
                border: "1px solid #C1C7CB",
              }}
            />
          )}
        </Typography>
        <Typography
          sx={{ fontSize: "1.1rem", color: "#1D4A87", fontWeight: "600" }}
        >
          {storeInformation?.storeInformation?.headerData?.storeTitle}
          {storeInformation?.storeInformation?.headerData?.isActive === true ? (
            <b style={{ color: "#28A745" }}> (فعال) </b>
          ) : (
            <b style={{ color: "#E6123D" }}> (غیر فعال) </b>
          )}
        </Typography>
      </Grid>
      {storeInformation?.storeInformation?.hideSale !== true ? (
        <Grid item>
          {storeInformation?.storeInformation?.headerData?.type === "Online" ? (
            <Typography
              sx={{
                fontSize: "1rem",
                color: "#1D4A87",
                backgroundColor: "#EDF1F4",
                padding: "5px 10px",
                borderRadius: "5px",
                marginLeft: "15px",
              }}
            >
              <LanguageRoundedIcon
                sx={{
                  fontSize: "20px",
                  marginLeft: "5px",
                }}
              />
              فروش آنلاین
            </Typography>
          ) : (
            <Typography
              sx={{
                fontSize: "1rem",
                color: "#1D4A87",
                backgroundColor: "#EDF1F4",
                padding: "5px 10px",
                borderRadius: "5px",
              }}
            >
              <StorefrontIcon
                sx={{
                  fontSize: "20px",
                  marginLeft: "5px",
                }}
              />
              فروش حضوری
            </Typography>
          )}
        </Grid>
      ) : null}
    </Grid>
  );
};

export default BranchHeader;
